//image
import { Component } from 'vue';

import IconBi from '@/assets/img/bi/bi.svg?component';
import IconAmerica from '@/assets/img/common/america.svg?component';
import IconJapan from '@/assets/img/common/japan.svg?component';
import IconSouthkorea from '@/assets/img/common/southkorea.svg?component';
import IconBonds from '@/components/atom/icon/IconBonds.vue';
import IconCommunications from '@/components/atom/icon/IconCommunications.vue';
import IconCompany from '@/components/atom/icon/IconCompany.vue';
import IconConsumerCyclical from '@/components/atom/icon/IconConsumerCyclical.vue';
import IconConsumerDefensive from '@/components/atom/icon/IconConsumerDefensive.vue';
import IconEnergy from '@/components/atom/icon/IconEnergy.vue';
import IconFinancial from '@/components/atom/icon/IconFinancial.vue';
import IconHealthCare from '@/components/atom/icon/IconHealthCare.vue';
import IconHighDividend from '@/components/atom/icon/IconHighDividend.vue';
import IconHotRankDefault from '@/components/atom/icon/IconHotRankDefault.vue';
import IconHotRankingIncome from '@/components/atom/icon/IconHotRankingIncome.vue';
import IconHotRankingInterest from '@/components/atom/icon/IconHotRankingInterest.vue';
import IconHotRankingPick from '@/components/atom/icon/IconHotRankingPick.vue';
import IconHotRankingProfitGrowth from '@/components/atom/icon/IconHotRankingProfitGrowth.vue';
import IconHotRankingSalesGrowth from '@/components/atom/icon/IconHotRankingSalesGrowth.vue';
import IconHotRankKR from '@/components/atom/icon/IconHotRankKR.vue';
import IconIndustrial from '@/components/atom/icon/IconIndustrial.vue';
import IconInfo from '@/components/atom/icon/IconInfo.vue';
import IconInverse from '@/components/atom/icon/IconInverse.vue';
import IconIt from '@/components/atom/icon/IconIt.vue';
import IconLeverage from '@/components/atom/icon/IconLeverage.vue';
import IconMaster from '@/components/atom/icon/IconMaster.vue';
// 구독 버튼 임시 주석 261023
// import IconPayment from '@/components/atom/icon/IconPayment.vue';
import IconPhone from '@/components/atom/icon/IconPhone.vue';
import IconRawMaterials from '@/components/atom/icon/IconRawMaterials.vue';
import IconReits from '@/components/atom/icon/IconReits.vue';
import IconSector from '@/components/atom/icon/IconSector.vue';
import IconSharing from '@/components/atom/icon/IconSharing.vue';
import IconSpeaker from '@/components/atom/icon/IconSpeaker.vue';
import IconStarMenu from '@/components/atom/icon/iconStarMenu.vue';
import IconSub from '@/components/atom/icon/IconSub.vue';
import IconTiming from '@/components/atom/icon/IconTiming.vue';
import IconUser from '@/components/atom/icon/IconUser.vue';
import IconUtilities from '@/components/atom/icon/IconUtilities.vue';

// 메인 메뉴 리스트
export const mainMenuListKR = [
	{
		title: '대가정보',
		group: 'master-info',
		path: '/master-info',
	},
	{
		title: 'Hot 랭킹',
		group: 'hot-ranking/kr',
		path: '/hot-ranking/kr',
	},
	{
		title: '이달의 포착주',
		group: 'subscribe',
		path: '/subscribe',
	},
	{
		title: '기업분석',
		group: 'company-analysis/kr',
		path: '/company-analysis/kr',
	},
	{
		title: '노하우 공유',
		group: 'protips',
		path: '/protips',
	},
];

export const mainMenuListUSA = [
	{
		title: '기업분석',
		group: 'company-analysis/usa',
		path: '/company-analysis/usa',
		icon: IconCompany,
	},
	// {
	// 	title: 'ETF',
	// 	group: 'etf',
	// 	path: '/etf',
	// 	icon: IconHotRank,
	// },
	{
		title: 'Hot 랭킹',
		group: 'hot-ranking/usa',
		path: '/hot-ranking/usa',
		icon: IconHotRankKR,
	},

	{
		title: '이달의 포착주',
		group: 'master-stocks/usa',
		path: '/master-stocks/usa',
		icon: IconMaster,
	},
	{
		title: '노하우 공유',
		group: 'protips',
		path: '/protips',
		icon: IconSharing,
	},
];

export const mainMenuListJPN = [
	{
		title: '기업분석',
		group: 'company-analysis/jpn',
		path: '/company-analysis/jpn',
	},
	{
		title: '이달의 포착주',
		group: 'master-stocks/jpn',
		path: '/master-stocks/jpn',
	},
	{
		title: 'Hot 랭킹',
		group: 'hot-ranking/jpn',
		path: '/hot-ranking/jpn',
	},
	{
		title: '노하우공유',
		group: 'protips',
		path: '/protips',
	},
];

type MobileMainMenuListType = {
	title: string;
	icon: Component;
	subMenu: {
		title: string;
		isHot?: boolean;
		group: string;
		path: string;
		isPremium?: boolean;
	}[];
};

// 모바일 메인 메뉴 리스트
export const mobileMainMenuList: MobileMainMenuListType[] = [
	{
		title: '시장 타이밍',
		icon: IconTiming,
		subMenu: [
			{
				title: '한국시장',
				isHot: false,
				group: 'market-timing/kr',
				path: '/market-timing/kr',
			},
			{
				title: '미국시장',
				isHot: false,
				group: 'market-timing/usa',
				path: '/market-timing/usa',
			},
			{
				title: '일본시장',
				isHot: false,
				group: 'market-timing/jpn',
				path: '/market-timing/jpn',
			},
			// {
			// 	title: '업종(한국)',
			// 	isHot: false,
			// 	group: 'market-timing/sector/kr',
			// 	path: '/market-timing/sector/kr',
			// },
		],
	},
	{
		title: '한국주식',
		icon: IconSouthkorea,
		subMenu: [
			{
				title: '대가정보',
				isHot: true,
				group: 'master-info',
				path: '/master-info',
			},
			{
				title: 'Hot랭킹',
				group: 'hot-ranking/kr',
				path: '/hot-ranking/kr',
				isPremium: true,
			},
			{
				title: '이달의 포착주',
				group: 'subscribe',
				path: '/subscribe',
			},
			{
				title: '기업분석',
				group: 'company-analysis/kr',
				path: '/company-analysis/kr',
			},
		],
	},
	{
		title: '미국주식',
		icon: IconAmerica,
		subMenu: [
			{
				title: 'Hot랭킹',
				isHot: false,
				group: 'hot-ranking/usa',
				path: '/hot-ranking/usa',
				isPremium: true,
			},
			{
				title: '이달의 포착주',
				isHot: true,
				group: 'master-stocks/usa',
				path: '/master-stocks/usa',
				isPremium: true,
			},
			{
				title: '상승률 상위 업종&테마',
				isHot: true,
				group: 'topgaining',
				path: '/topgaining',
			},
			// {
			// 	title: 'ETF',
			// 	isHot: false,
			// 	group: 'etf',
			// 	path: '/etf',
			// },
			// {
			// 	title: '큰손들의 실제 보유종목',
			// 	isHot: false,
			// 	group: 'holdings',
			// 	path: '/holdings',
			// },
			{
				title: '기업분석',
				group: 'company-analysis/usa',
				path: '/company-analysis/usa',
			},
		],
	},
	{
		title: '일본주식',
		icon: IconJapan,
		subMenu: [
			{
				title: 'Hot랭킹',
				isHot: false,
				group: 'hot-ranking/jpn',
				path: '/hot-ranking/jpn',
				isPremium: true,
			},
			{
				title: '이달의 포착주',
				isHot: true,
				group: 'master-stocks/jpn',
				path: '/master-stocks/jpn',
				isPremium: true,
			},
			{
				title: '기업분석',
				group: 'company-analysis/jpn',
				path: '/company-analysis/jpn',
			},
		],
	},
	{
		title: '대가의선택',
		icon: IconBi,
		subMenu: [
			// {
			// 	title: '대가MALL',
			// 	isHot: true,
			// 	group: 'Mall',
			// 	path: '',
			// },
			{
				title: '노하우 공유',
				group: 'protips',
				path: '/protips',
			},
			// {
			// 	title: '대가의 혜택',
			// 	group: 'benefit',
			// 	path: '/benefit',
			// },
			{
				title: '구독안내',
				group: 'Guide',
				path: '/notice-detail/21',
			},
			// {
			// 	title: '고객소리함',
			// 	group: 'feedback',
			// 	path: '/feedback',
			// },
		],
	},
];

export const moreMenuBoxList = [
	{
		title: '관심종목',
		group: 'interest',
		icon: IconStarMenu,
		path: '',
	},
	// 구독 버튼 임시 주석 261023
	// {
	// 	title: '구독하기',
	// 	group: 'payment',
	// 	icon: IconPayment,
	// 	path: '/payment',
	// },
	{
		title: '공지사항',
		group: 'notice',
		icon: IconSpeaker,
		path: '/notice',
	},
	{
		title: '활용법',
		group: 'Use',
		icon: IconPhone,
		path: '/notice-detail/188',
	},
];

export const bottomNavMenuKRList = [
	{
		title: '대가정보',
		group: 'master-info',
		path: '/master-info',
		icon: IconInfo,
	},
	{
		title: 'Hot 랭킹',
		group: 'hot-ranking/kr',
		path: '/hot-ranking/kr',
		icon: IconHotRankKR,
	},
	{
		title: '이달의 포착주',
		group: 'subscribe',
		path: '/subscribe',
		icon: IconSub,
	},
	{
		title: '노하우 공유',
		group: 'protips',
		path: '/protips',
		icon: IconSharing,
	},
	{
		title: '내 정보',
		group: 'my',
		path: '/my',
		icon: IconUser,
	},
];

export const bottomNavMenuUSAList = [
	{
		title: '기업분석',
		group: 'company-analysis/usa',
		path: '/company-analysis/usa',
		icon: IconCompany,
	},
	// {
	// 	title: 'ETF',
	// 	group: 'etf',
	// 	path: '/etf',
	// 	icon: IconHotRank,
	// },
	{
		title: 'Hot 랭킹',
		group: 'hot-ranking/usa',
		path: '/hot-ranking/usa',
		icon: IconHotRankKR,
	},

	{
		title: '이달의 포착주',
		group: 'master-stocks/usa',
		path: '/master-stocks/usa',
		icon: IconMaster,
	},
	{
		title: '노하우 공유',
		group: 'protips',
		path: '/protips',
		icon: IconSharing,
	},
	{
		title: '내 정보',
		group: 'my',
		path: '/my',
		icon: IconUser,
	},
];

export const bottomNavMenuJPNList = [
	{
		title: '기업분석',
		group: 'company-analysis/jpn',
		path: '/company-analysis/jpn',
		icon: IconCompany,
	},
	{
		title: 'Hot 랭킹',
		group: 'hot-ranking/jpn',
		path: '/hot-ranking/jpn',
		icon: IconHotRankKR,
	},
	{
		title: '이달의 포착주',
		group: 'master-stocks/jpn',
		path: '/master-stocks/jpn',
		icon: IconMaster,
	},
	{
		title: '노하우 공유',
		group: 'protips',
		path: '/protips',
		icon: IconSharing,
	},
	{
		title: '내 정보',
		group: 'my',
		path: '/my',
		icon: IconUser,
	},
];

// 마이페이지 메뉴 리스트
export const mypageMenuList = [
	{
		title: '구독 내역',
		group: 'my/history',
		path: '/my/history',
	},
	{
		title: '내 정보 변경',
		group: 'my/edit',
		path: '/my/edit',
	},
	{
		title: '비밀번호 변경',
		group: 'my/pw-change',
		path: '/my/pw-change',
	},
	{
		title: '서비스 이용약관',
		group: 'my/terms-service',
		path: '/my/terms-service',
	},
	{
		title: '개인정보 처리방침',
		group: 'my/privacy-policy',
		path: '/my/privacy-policy',
	},
];

export const sectorMenuList = [
	{
		tab: '정보기술',
		icon: IconIt,
	},
	{
		tab: '헬스케어',
		icon: IconHealthCare,
	},
	{
		tab: '금융',
		icon: IconFinancial,
	},
	{
		tab: '통신서비스',
		icon: IconCommunications,
	},
	{
		tab: '임의소비재',
		icon: IconConsumerDefensive,
	},
	{
		tab: '필수소비재',
		icon: IconConsumerCyclical,
	},
	{
		tab: '산업',
		icon: IconIndustrial,
	},
	{
		tab: '유틸리티',
		icon: IconUtilities,
	},
	{
		tab: '에너지',
		icon: IconEnergy,
	},
	{
		tab: '부동산',
		icon: IconReits,
	},
	{
		tab: '원자재/소재',
		icon: IconRawMaterials,
	},
];
export const master = [
	'피터린치',
	'필립피셔',
	'벤자민 그레이엄',
	'윌리엄 오닐',
	'존네프',
	'조엘 그린블라트',
	'워렌버핏',
];

export type tabMenu = {
	title: string;
	group: string;
};

export const tabInterestMenuList = [
	'ALL',
	'피터 린치',
	'워런 버핏',
	'필립 피셔',
	'벤저민 그레이엄',
	'윌리엄 오닐',
	'존네프',
	'조엘 그린블라트',
];

// 투자리포트/재무재표
export const detailTabItems = ['연간', '분기'];

// 관심종목
export const interestMenuList = [
	{ title: '한국주식', path: '/interest/kr' },
	{ title: '미국주식', path: '/interest/usa' },
	{ title: '일본주식', path: '/interest/jpn' },
];

// ETF
export const etfBusinessOverviewItems = ['상장일', '운용사', '자산규모', '총보수'];

// 핫랭킹(US)
export type HotRankMainGridType = {
	icon: Component; // Vue 컴포넌트로서의 아이콘
	title: string; // 카드의 제목
	top_sub: string; // 상단 서브타이틀 또는 설명
	bottom_sub?: string; // 하단 서브타이틀 또는 설명
};
export const HotRankMainGridData = [
	{
		icon: IconHotRankingPick,
		title: '대가’S PICK',
		top_sub: '7인 대가가 선택한 공통의 종목을 소개합니다.',
	},
	{
		icon: IconHotRankingInterest,
		title: '관심테마 TOP3',
		top_sub: '7인 대가가 가장 많은 관심을 가지는 테마를 소개합니다.',
	},
	{
		icon: IconHotRankingSalesGrowth,
		title: '매출액 급성장',
		top_sub: '매출액이 가장 많이 증가한 기업을 소개합니다.',
	},
	{
		icon: IconHotRankingProfitGrowth,
		title: '이익 급성장',
		top_sub: '영업이익이 가장 많이 증가한 기업을 소개합니다.',
	},
	{
		icon: IconHotRankingIncome,
		title: '배당 수익률 TOP5',
		top_sub: '배당 수익률이 높은 기업을 소개합니다.',
	},
];
export const EtfGridData = [
	{
		icon: IconHotRankDefault,
		title: '지수추종',
		top_sub: '단순하지만 확실한 투자!',
		bottom_sub: '시장의 흐름을 따라간다',
	},
	{ icon: IconSector, title: '섹터', top_sub: '유망한 산업인건 알겠는데...', bottom_sub: '대장주를 모르겠다면?' },
	{
		icon: IconLeverage,
		title: '레버리지',
		top_sub: '더 높은 수익을 원한다면?! ',
		bottom_sub: '상승에 강력 배팅!',
	},
	{
		icon: IconInverse,
		title: '인버스',
		top_sub: '경기가 불안하다면?',
		bottom_sub: '하락에 배팅하라!',
	},
	{
		icon: IconBonds,
		title: '채권',
		top_sub: '안정적 투자를 원한다면?',
		bottom_sub: '워런버핏도 사는 채권!',
	},
	{
		icon: IconHighDividend,
		title: '고배당',
		top_sub: "‘배당'수익과 '시세차익'",
		bottom_sub: '두마리 토끼를 한번에!',
	},
];
